import en from "./en.json";
import it from "./it.json";

const collection = { en, it };

export default collection;
